<template>
    <div id="bene-basic-1-container">
        <f7-list form class="form-group">
            <f7-list-input
                input-id     ="beneficiaryName"
                name         ="beneficiaryName"
                type         ="text"

                v-if         ="showFormInput.root.beneficiaryName"
                :label       ="beneficiaryNameLabel"
                :placeholder ="beneficiaryNameLabel"
                :value       ="beneficiaryName"
                @change      ="setBeneficiaryName($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="100"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="nickname"
                name         ="nickname"
                type         ="text"

                v-if         ="showFormInput.root.nickname"
                :label       ="$t('beneficiary-nickname')"
                :placeholder ="$t('beneficiary-nickname')"
                :value       ="nickname"
                @change      ="setNickname($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="100"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="identificationType"
                name         ="identificationType"
                type         ="text"

                v-if         ="showFormInput.root.identificationType"
                :label       ="identificationTypeLabel"
                :placeholder ="identificationTypeLabel"
                :value       ="identificationType"
                @change      ="setIdentificationType($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="50"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>

            <f7-list-input
                input-id     ="idTypeSelect"
                id           ="idTypeSelectInput"
                name         ="idTypeSelect"
                class        ="clickable-row use-chevron"

                v-if         ="showFormInput.root.idTypeSelect"
                :label       ="$t('beneficiary-beneficiary-id-type')"
                :placeholder ="$t('beneficiary-select-beneficiary-id-type')"
                :value       ="idTypeSelect"
                @change      ="setIdTypeSelect($event.target.value);"

                outline
                floating-label
            >
                <f7-link popover-open=".popover-dropdown-id-type" slot="content-start" class="clickable-item"></f7-link>
            </f7-list-input>

            <f7-popover id="dropdownIdTypeSelect" class="popover-dropdown-id-type dropdown-default dropdown beneficiary" :backdrop="true">
                <f7-list>
                    <f7-list-item popover-close link="#"
                    v-for="(it, key) in idTypeList"
                    :key="key"
                    selected=""
                    @click="changeIdType(key); validateInput($event.target); setInput('idTypeSelect');">
                    {{it}}
                    </f7-list-item>
                </f7-list>
            </f7-popover>

            <f7-list-input
                input-id     ="identificationNo"
                name         ="identificationNo"
                type         ="text"

                v-if         ="showFormInput.root.identificationNo"
                :label       ="identificationNoLabel"
                :placeholder ="identificationNoLabel"
                :value       ="identificationNo"
                @change      ="setIdentificationNo($event.target.value); validateInput($event.target); setInput($event.target)"

                maxlength    ="30"
                autocomplete ="off"
                outline
                floating-label
                clear-button
            ></f7-list-input>
        </f7-list>
    </div>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    export default {
        props: {
        },
        mounted() {
            this.init();
        },
        data: function() {
            return {}
        },
        computed: {
            ...mapGetters('beneficiary', [
                'showFormSet',
                'showFormInput',
                'beneficiaryNameLabel',
                'beneficiaryName',
                'nickname',
                'identificationTypeLabel',
                'identificationType',
                'idTypeSelect',
                'idTypeSelectId',
                'idTypeList',
                'identificationNoLabel',
                'identificationNo',
            ])
        },
        methods: {
            ...mapActions('beneficiary', [
                'setBeneficiaryName',
                'setBeneficiaryType',
                'setNickname',
                'setIdentificationType',
                'setIdTypeSelect',
                'setIdentificationNo',
            ]),

            async init() {
                //await this.renderDropdown();

                const self    = this;
                const popover = ".beneficiary.popover-dropdown-id-type";
                const popoverInner = ".beneficiary.popover-dropdown-id-type .popover-inner";
                const popoverId = "dropdownIdTypeSelect";
                const inputId = "idTypeSelect";
                const inputListId = "#idTypeSelectInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)
            },

            renderDropdown() {
                const self = this;

                self.Dom7('.beneficiary.popover-dropdown-id-type').on('popover:open', function() {
                    self.$$(".beneficiary.popover-dropdown-id-type").css({
                        'visibility' : 'hidden',
                    });
                });

                self.Dom7('.beneficiary.popover-dropdown-id-type').on('popover:opened', function() {
                    var thepopover = self.Dom7('.beneficiary.popover-dropdown-id-type');
                    const classes = thepopover[0].firstChild.classList;
                    const popoverDirection = classes[1];
                    console.log("BENEFICIARY TYPE direction: "+popoverDirection)

                    const parentPosBottom = document.getElementById('idTypeSelect').getBoundingClientRect().bottom;
                    const parentPosLeft = document.getElementById('idTypeSelect').getBoundingClientRect().left;

                    self.$$("#idTypeSelectInput").removeClass("dropdown-list").addClass("dropdown-list");

                    self.$$(".beneficiary.popover-dropdown-id-type").css({
                            'visibility' : 'visible',
                        'top' : (parentPosBottom) + 'px',
                        'margin-left' : (parentPosLeft) + 'px'
                    });
                });

                self.Dom7('.beneficiary.popover-dropdown-id-type').on('popover:closed', function() {
                    self.$$("#idTypeSelectInput").removeClass("dropdown-list");
                });
            },

            changeIdType(id) {
                this.$emit("changeIdType", id);
            },

            validateInput(inputEl) {
                this.$emit("validateInput", inputEl);
            },

            setInput(inputEl) {
                this.$emit("setInput", inputEl);
            }
        }
    }
</script>